'use strict';

/*! main.js */

function gestionaForms() {
	var empty = true;
	$('input[type=text]').on('change', function () {
		empty = $(this).val().trim() === '' ? true : false;
	});
	$('.bastidor, .codigo').on('change', function () {
		var valor = $(this).val();
		$('.bastidor, .codigo').val('');
		$(this).val(valor);
	});
	$('form:not(#js-form-envio)').on('submit', function (e) {
		if (empty) e.preventDefault();
	});
}

$(function () {
	gestionaForms();
});

function searchVIN() {
	$('.aop-buscar-bastidor .js-error').hide();
	var VIN = typeof $(".h-submenu #txt-bastidor").val() != 'undefined' && $(".h-submenu #txt-bastidor").val().trim() !== '' ? $(".h-submenu #txt-bastidor").val().trim() : $(".desktop #txt-bastidor").val().trim() !== '' ? $(".desktop #txt-bastidor").val().trim() : $(".mobile #txt-bastidor").val().trim();
	$("#bastidor-error").val("");

	if (VIN != "" && VIN.length !== 17) {
		$('.js-bastidor-error-length').show();
	} else if (VIN != "") {
		$.ajax({
			url: "accesorios-one-place?pMode=searchVIN&pVIN=" + VIN,
			method: "POST",
			dataType: "text"

		}).done(function (data) {
			if (data.indexOf("MOI=") > -1) {
				window.location.href = "accesorios-one-place?pMode=searchCategoriesSubcategories&mercado=ESP&moi=" + data.replace("MOI=", "");
			} else $(".js-bastidor-error").slideDown();
		});
	} else {
		$(".js-bastidor-error-empty").slideDown();
	}

	return false;
}
function searchCodCom() {
	$('.aop-buscar-codigo .js-error').hide();
	var codCom = typeof $(".h-submenu #txt-codcom").val() != 'undefined' && $(".h-submenu #txt-codcom").val().trim() !== '' ? $(".h-submenu #txt-codcom").val().trim() : $(".desktop #txt-codcom").val().trim() !== '' ? $(".desktop #txt-codcom").val().trim() : $(".mobile #txt-codcom").val().trim();
	$("#codcom-error").val("");

	if (codCom != "" && !(codCom.length === 13 || codCom.length === 17)) {
		$('.js-codcom-error-length').show();
	} else if (codCom != "") {
		$.ajax({
			url: "accesorios-one-place?pMode=searchCodCom&pCodCom=" + codCom,
			method: "POST",
			dataType: "text"

		}).done(function (data) {
			if (data.indexOf("MOI=") > -1) {
				window.location.href = "accesorios-one-place?pMode=searchCategoriesSubcategories&mercado=ESP&moi=" + data.replace("MOI=", "");
			} else {
				$(".js-codcom-error").slideDown();
			}
		});
	} else {
		$(".js-codcom-error-empty").slideDown();
	}

	return false;
}

function abreVideo() {
	$.colorbox({
		href: '#video',
		inline: true,
		width: '90%',
		maxWidth: '1000px',
		opacity: 0.75,
		onCleanup: function onCleanup() {
			$('#video').empty();
		}
	});
}